/*!
 * Copyright (c) 2023 Digital Bazaar, Inc. All rights reserved.
 */
export const name = 'eddsa-rdfc-2022';
